var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 2C2.44772 2 2 2.44772 2 3V17C2 17.5523 2.44772 18 3 18H17C17.5523 18 18 17.5523 18 17V3C18 2.44772 17.5523 2 17 2H3ZM0 3C0 1.34315 1.34315 0 3 0H17C18.6569 0 20 1.34315 20 3V17C20 18.6569 18.6569 20 17 20H3C1.34315 20 0 18.6569 0 17V3Z",
    fill: "#776F6A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 4.375H5C4.6548 4.375 4.375 4.6548 4.375 5V6.25C4.375 6.5952 4.6548 6.875 5 6.875H6.25C6.5952 6.875 6.875 6.5952 6.875 6.25V5C6.875 4.6548 6.5952 4.375 6.25 4.375Z",
    fill: "#776F6A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 8.75H5C4.6548 8.75 4.375 9.0298 4.375 9.375V10.625C4.375 10.9702 4.6548 11.25 5 11.25H6.25C6.5952 11.25 6.875 10.9702 6.875 10.625V9.375C6.875 9.0298 6.5952 8.75 6.25 8.75Z",
    fill: "#776F6A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 13.125H5C4.6548 13.125 4.375 13.4048 4.375 13.75V15C4.375 15.3452 4.6548 15.625 5 15.625H6.25C6.5952 15.625 6.875 15.3452 6.875 15V13.75C6.875 13.4048 6.5952 13.125 6.25 13.125Z",
    fill: "#776F6A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.625 5H8.125V6.25H15.625V5Z",
    fill: "#776F6A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.625 9.375H8.125V10.625H15.625V9.375Z",
    fill: "#776F6A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.625 13.75H8.125V15H15.625V13.75Z",
    fill: "#776F6A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcon);
export default __webpack_public_path__ + "static/media/menu_icon.26f92e8c5e393348817e30ac3df3624e.svg";
export { ForwardRef as ReactComponent };